<div class="container">
  <div class="container-table">
    <header class="top-header">
      <h3>{{ isEdit ? 'Edit Subscription' : 'Create Subscription' }}</h3>
    </header>

    <form [formGroup]="form" novalidate>
      <div class="section-card">
        <div class="section-title">Customer Contact</div>
        <div class="form-grid">
          <label *ngIf="isSuperUser">
            Organization
            <select formControlName="organization" [class.invalid-input]="isInvalid('organization')">
              <option value="">Select</option>
              <option *ngFor="let org of organizations" [value]="org.id">{{ org.name }}</option>
            </select>
            <!-- <span class="error" *ngIf="isInvalid('organization')">Organization is required.</span> -->
            <div class="error" *ngIf="form.get('organization')?.invalid && form.get('organization')?.touched">
              <small *ngIf="form.get('organization')?.errors?.['required']">Organization is required.</small>

            </div>
          </label>
          <label>
            Customer POC Name
            <input type="text" formControlName="customer_poc_name" [class.invalid-input]="isInvalid('customer_poc_name')" />
            <div class="error" *ngIf="form.get('customer_poc_name')?.invalid && form.get('customer_poc_name')?.touched">
              <small *ngIf="form.get('customer_poc_name')?.errors?.['required']">Customer POC name is required.</small>
              <small *ngIf="form.get('customer_poc_name')?.errors?.['maxlength']">Max 255 characters.</small>
            </div>
          </label>
          <label>
            Customer POC Email
            <input type="email" formControlName="customer_poc_email" [class.invalid-input]="isInvalid('customer_poc_email')" />
            <div class="error" *ngIf="form.get('customer_poc_email')?.invalid && form.get('customer_poc_email')?.touched">
              <small *ngIf="form.get('customer_poc_email')?.errors?.['required']">Customer POC email is required.</small>
              <small *ngIf="form.get('customer_poc_email')?.errors?.['email']">Enter a valid email.</small>
            </div>

          </label>
          <label>
            Customer POC Phone
            <input type="text" formControlName="customer_poc_phone" [class.invalid-input]="isInvalid('customer_poc_phone')" />
            <div class="error" *ngIf="form.get('customer_poc_phone')?.invalid && form.get('customer_poc_phone')?.touched">
              <small *ngIf="form.get('customer_poc_phone')?.errors?.['required']">Customer POC phone is required.</small>
              <small *ngIf="form.get('customer_poc_phone')?.errors?.['pattern']">Enter 8-20 digits.</small>
            </div>
          </label>
        </div>
      </div>

      <div class="section-card">
        <div class="section-title">Kyra Sales Contact</div>
        <div class="form-grid">
          <label>
            Kyra Sales POC Name
            <input type="text" formControlName="kyra_sales_poc_name" [class.invalid-input]="isInvalid('kyra_sales_poc_name')" />
            <div class="error" *ngIf="form.get('kyra_sales_poc_name')?.invalid && form.get('kyra_sales_poc_name')?.touched">
              <small *ngIf="form.get('kyra_sales_poc_name')?.errors?.['maxlength']">Max 255 characters.</small>
            </div>
          </label>
          <label>
            Kyra Sales POC Email
            <input type="email" formControlName="kyra_sales_poc_email" [class.invalid-input]="isInvalid('kyra_sales_poc_email')" />
            <div class="error" *ngIf="form.get('kyra_sales_poc_email')?.invalid && form.get('kyra_sales_poc_email')?.touched">
              <small *ngIf="form.get('kyra_sales_poc_email')?.errors?.['email']">Enter a valid email.</small>
            </div>
          </label>
          <label>
            Kyra Sales POC Phone
            <input type="text" formControlName="kyra_sales_poc_phone" [class.invalid-input]="isInvalid('kyra_sales_poc_phone')" />
            <div class="error" *ngIf="form.get('kyra_sales_poc_phone')?.invalid && form.get('kyra_sales_poc_phone')?.touched">
              <small *ngIf="form.get('kyra_sales_poc_phone')?.errors?.['pattern']">Enter 8-20 digits.</small>
            </div>
          </label>
        </div>
      </div>

      <div class="section-card">
        <div class="section-title">Contract Details</div>
        <div class="form-grid">
          <label>
            Billing Type
            <select formControlName="billing_type" [class.invalid-input]="isInvalid('billing_type')">
              <option value="ANNUAL">Annual</option>
              <option value="UPFRONT">Upfront</option>
            </select>
            <div class="error" *ngIf="form.get('billing_type')?.invalid && form.get('billing_type')?.touched">
              <small *ngIf="form.get('billing_type')?.errors?.['required']">Billing type is required.</small>
            </div>
          </label>
          <label>
            Subscription Start Date
            <input type="date" formControlName="start_date" [class.invalid-input]="isInvalid('start_date')" />
            <div class="error" *ngIf="form.get('start_date')?.invalid && form.get('start_date')?.touched">
              <small *ngIf="form.get('start_date')?.errors?.['required']">Start date is required.</small>
            </div>
          </label>
          <label>
            Contract Duration (years)
            <input type="number" min="1" formControlName="contract_duration_years"
              [class.invalid-input]="isInvalid('contract_duration_years')" />

            <div class="error"
              *ngIf="form.get('contract_duration_years')?.invalid && form.get('contract_duration_years')?.touched">
              <small *ngIf="form.get('contract_duration_years')?.errors?.['required']">Duration is required.</small>
              <small *ngIf="form.get('contract_duration_years')?.errors?.['min']">Minimum 1 year.</small>
            </div>
          </label>
          <label>
            Total Amount
            <input type="number" min="0" formControlName="total_amount"
              [class.invalid-input]="isInvalid('total_amount')" />
            <div class="error" *ngIf="form.get('total_amount')?.invalid && form.get('total_amount')?.touched">
              <small *ngIf="form.get('total_amount')?.errors?.['required']">Total amount is required.</small>
              <small *ngIf="form.get('total_amount')?.errors?.['min']">Must be greater than 0.</small>
            </div>
          </label>
          <label>
            Currency
            <input type="text" formControlName="currency" [class.invalid-input]="isInvalid('currency')" />
            <div class="error" *ngIf="form.get('currency')?.invalid && form.get('currency')?.touched">
              <small *ngIf="form.get('currency')?.errors?.['required']">Currency is required.</small>
              <small *ngIf="form.get('currency')?.errors?.['pattern']">Use 3-letter code (e.g., INR).</small>
            </div>
          </label>
          <label>
            No. of Cameras
            <input type="number" min="0" formControlName="camera_count" [class.invalid-input]="isInvalid('camera_count')" />
            <div class="error" *ngIf="form.get('camera_count')?.invalid && form.get('camera_count')?.touched">
              <small *ngIf="form.get('camera_count')?.errors?.['min']">Cannot be negative.</small>
            </div>
          </label>
          <label>
            Contract End Date
            <input type="date" formControlName="expiry_date" readonly>
          </label>
        </div>
      </div>
      <div class="container-table">
        <!-- <header class="top-header"> -->
        <div class="section-title">
          <div class="item-section">
            <h4>Items</h4>
            <p class="muted">Tag items as recurring or one-time. Use year to scope charges</p>
          </div>
          <div class="item-section">
            <button type="button" (click)="addItem()" class="btn-action">
              <fa-icon [icon]="['fas', 'square-plus']" class="fa-thin" style="color: white;font-size: 15px;"></fa-icon>
              ADD ITEM
            </button>
          </div>
        </div>

        <!-- </header> -->
        <div>
          <div class="responsive-table-wrapper">
            <table class="items-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>HSN/SAC</th>
                  <th>Qty</th>
                  <th>Unit Price</th>
                  <th>Tax</th>
                  <th>Recurring</th>
                  <th>One Time</th>
                  <th>Year</th>
                  <th></th>
                </tr>
              </thead>
              <tbody formArrayName="items" *ngIf="itemsArray">

                <tr *ngFor="let item of itemsControls; let i = index" [formGroupName]="i">
                  <td>
                    <input type="text" formControlName="name" [class.invalid-input]="isItemInvalid(item, 'name')" />
                    <div class="error" *ngIf="isItemInvalid(item, 'name')">
                      <small>Required.</small>
                    </div>
                  </td>
                  <td>
                    <input type="text" formControlName="hsn_sac" />
                  </td>
                  <td>
                    <input type="number" min="1" formControlName="quantity"
                      [class.invalid-input]="isItemInvalid(item, 'quantity')" />
                    <!-- <span class="error" *ngIf="isItemInvalid(item, 'quantity')">Min 1.</span> -->
                    <div class="error" *ngIf="isItemInvalid(item, 'quantity')">
                      <small>>Min 1.</small>
                    </div>
                  </td>
                  <td>
                    <input type="number" min="0" formControlName="unit_price"
                      [class.invalid-input]="isItemInvalid(item, 'unit_price')" />
                    <!-- <span class="error" *ngIf="isItemInvalid(item, 'unit_price')">Min 0.</span> -->
                    <div class="error" *ngIf="isItemInvalid(item, 'unit_price')">
                      <small>Min 0.</small>
                    </div>
                  </td>
                  <td>
                    <input type="number" min="0" formControlName="tax"
                      [class.invalid-input]="isItemInvalid(item, 'tax')" />
                    <!-- <span class="error" *ngIf="isItemInvalid(item, 'tax')">Min 0.</span> -->
                    <div class="error" *ngIf="isItemInvalid(item, 'tax')">
                      <small>>Min 0.</small>
                    </div>
                  </td>
                  <!-- <td>
                    <input type="checkbox" formControlName="is_recurring" />
                  </td>
                  <td>
                    <input type="checkbox" formControlName="is_one_time" />
                  </td> -->
                  <td>
                    <div class="cell-input-align">
                      <input type="checkbox" formControlName="is_recurring" />
                    </div>
                  </td>
                  <td>
                    <div class="cell-input-align">
                      <input type="checkbox" formControlName="is_one_time" />
                    </div>
                  </td>
                  <td>
                    <input type="number" min="1" formControlName="year_applicable"
                      [class.invalid-input]="isItemInvalid(item, 'year_applicable')" />
                    <!-- <span class="error" *ngIf="isItemInvalid(item, 'year_applicable')">
                      <span *ngIf="item.get('year_applicable')?.errors?.['min']">Min 1.</span>
                      <span *ngIf="item.get('year_applicable')?.errors?.['max']">Exceeds duration.</span>
                    </span> -->
                    <!-- <span class="error" *ngIf="itemFlagInvalid(item)">Select recurring, one-time, or set year.</span> -->
                    <div class="error" *ngIf="isItemInvalid(item, 'year_applicable')">
                      <small *ngIf="item.get('year_applicable')?.errors?.['min']">Min 1.</small>
                      <small *ngIf="item.get('year_applicable')?.errors?.['max']">Exceeds duration.</small>
                    </div>
                    <div class="error" *ngIf="itemFlagInvalid(item)">
                      <small>Select recurring, one-time, or set year.</small>
                    </div>
                  </td>
                  <!-- <td>
                    <button type="button" class="action-button bt-delete" (click)="removeItem(i)">
                      <span>
                        <fa-icon [icon]="['fas', 'trash']" class="fa-light"></fa-icon>
                      </span>
                    </button>
                  </td> -->
                  <td>
                    <div class="cell-input-align">
                      <button type="button" class="action-button bt-delete" (click)="removeItem(i)">
                        <fa-icon [icon]="['fas', 'trash']" class="fa-light"></fa-icon>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="itemsControls.length === 0">
                  <td colspan="9">No items added.</td>
                </tr>
              </tbody>
            </table>

            <!-- <div class="footer">
              <div class="total-records">Total Records: {{ totalRecords }}</div>
              <div class="pagination-controls">
                <label for="recordsPerPage">Records per page </label>
                <select id="recordsPerPage" [(ngModel)]="recordsPerPage" (change)="selectPageSize()">
                  <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
                </select>
                <span>{{ currentPage }} / {{ totalPages }}</span>
                <button (click)="previous()" [disabled]="!previousPage" class="change-page" title="Previous page">
                  <fa-icon [icon]="['fas', 'angle-left']" class="fa-light"></fa-icon>
                </button>
                <button (click)="next()" [disabled]="!nextPage" class="change-page" title="Next page">
                  <fa-icon [icon]="['fas', 'angle-right']" class="fa-light" style="background-color: none;"></fa-icon>
                </button>
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <!-- <div class="section-card" formArrayName="items">
        <div class="section-header">
          <div>
            <h4>Items</h4>
            <p class="muted">Tag items as recurring or one-time. Use year to scope charges.</p>
          </div>
          <button type="button" class="action-button" (click)="addItem()">Add Item</button>
        </div>
        <div class="table-wrapper">
          <table class="items-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Qty</th>
                <th>Unit Price</th>
                <th>Tax</th>
                <th>Recurring</th>
                <th>One Time</th>
                <th>Year</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of itemsControls; let i = index" [formGroupName]="i">
                <td>
                  <input type="text" formControlName="name" [class.invalid-input]="isItemInvalid(item, 'name')" />
                  <span class="error" *ngIf="isItemInvalid(item, 'name')">Required.</span>
                </td>
                <td>
                  <input type="number" min="1" formControlName="quantity" [class.invalid-input]="isItemInvalid(item, 'quantity')" />
                  <span class="error" *ngIf="isItemInvalid(item, 'quantity')">Min 1.</span>
                </td>
                <td>
                  <input type="number" min="0" formControlName="unit_price" [class.invalid-input]="isItemInvalid(item, 'unit_price')" />
                  <span class="error" *ngIf="isItemInvalid(item, 'unit_price')">Min 0.</span>
                </td>
                <td>
                  <input type="number" min="0" formControlName="tax" [class.invalid-input]="isItemInvalid(item, 'tax')" />
                  <span class="error" *ngIf="isItemInvalid(item, 'tax')">Min 0.</span>
                </td>
                <td>
                  <input type="checkbox" formControlName="is_recurring" />
                </td>
                <td>
                  <input type="checkbox" formControlName="is_one_time" />
                </td>
                <td>
                  <input type="number" min="1" formControlName="year_applicable" [class.invalid-input]="isItemInvalid(item, 'year_applicable')" />
                  <span class="error" *ngIf="isItemInvalid(item, 'year_applicable')">
                    <span *ngIf="item.get('year_applicable')?.errors?.['min']">Min 1.</span>
                    <span *ngIf="item.get('year_applicable')?.errors?.['max']">Exceeds duration.</span>
                  </span>
                  <span class="error" *ngIf="itemFlagInvalid(item)">Select recurring, one-time, or set year.</span>
                </td>
                <td class="items-action">
                  <button type="button" class="action-button danger" (click)="removeItem(i)">Remove</button>
                </td>
              </tr>
              <tr *ngIf="itemsControls.length === 0">
                <td colspan="8">No items added.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div> -->

      <!-- <div class="form-actions">
        <button type="button" class="export-button" (click)="save()" [disabled]="form.invalid">Save</button>
        <button type="button" class="action-button" (click)="cancel()">Cancel</button>
      </div> -->

      <div class="button-row">
        <button class="btn-cancel" type="button" (click)="cancel()" [disabled]="saving">
          <fa-icon [icon]="['fas', 'square-xmark']" style="padding-right: 3px;"></fa-icon>
          Cancel
        </button>
        <button class="btn-save" type="button" (click)="save()" [disabled]="form.invalid || saving">
          <fa-icon [icon]="['fas', 'square-plus']" style="padding-right: 3px;"></fa-icon>
          {{ saving ? 'Saving...' : 'Save' }}
        </button>
      </div>

    </form>
  </div>
</div>
